module.exports = __webpack_public_path__ + "static/media/coffee.d638ee1f.png";